import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { notificationsBackend } from './notifications.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { notificationsReducer } from './notifications.reducer';

// FIXME: remove that
backend.notifications = notificationsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('notifications', notificationsReducer),
    /* DatastoreBackendModule.forFeature(
      'notifications',
      notificationsBackend,
    ),*/
  ],
})
export class DatastoreNotificationsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/notifications/notifications.module.ts